import { createButtonStore } from '@/components/OfferButton/store'

const createDiscountModalStore = createButtonStore('discount_modal')

export const useDiscountModalStore = () => createDiscountModalStore()
